export const SET_WORKOUTS = 'SET_WORKOUTS'
export const SET_WORKOUT = 'SET_WORKOUT'
export const SET_WORKOUT_DATA = 'SET_WORKOUT_DATA'
export const RESET_WORKOUT = 'RESET_WORKOUT'
export const SET_CHECKED = 'SET_CHECKED'
export const SET_PAGER = 'SET_PAGER'
export const SET_CLASSES = 'SET_CLASSES'

export const STORE_PAGER = 'workouts/pager'
